const cars = [
  {
    id: 1,
    name: "HONDA VEZEL",
    image: "/cars/Honda_Vezel.jpg"
  },
  {
    id: 2,
    name: "Toyota Raize",
    image: "/cars/Toyota_Raize.jpg"
  },
  {
    id: 3,
    name: "Toyota Yaris",
    image: "/cars/Toyota_Yaris.jpg"
  },
  {
    id: 4,
    name: "Suzuki WagonR",
    image: "/cars/Suzuki_WagonR.jpg"
  }
];

export default cars;